import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { useStaticQuery, graphql } from 'gatsby'
import Search from './Search'
import { createGlobalStyle } from '@xstyled/styled-components'
import { MdSearch } from 'react-icons/md'

import { useAsync } from 'react-async-hook'

const fetchSearchUrl = async url => (await fetch(url)).json()

const GlobalStyle = createGlobalStyle`
  .overlay {
    background: none;
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 11;
  }
  .modal {
    left: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 56rem;
    padding-left: 1rem;
    padding-right: 1rem;
    position: absolute;
    right: 0;
    top: 3rem;
  }
`

export default function SearchModal() {
  const data = useStaticQuery(graphql`
    query SearchLoad {
      localSearchPages {
        publicIndexURL
        publicStoreURL
      }
    }
  `)
  const [modalIsOpen, setIsOpen] = useState(false)

  // load the search Index and Store, then pass them into the search component
  const asyncIndex = useAsync(fetchSearchUrl, [data.localSearchPages.publicIndexURL])
  const asyncStore = useAsync(fetchSearchUrl, [data.localSearchPages.publicStoreURL])

  function onSlashKey(e) {
    if (e.code === 'Slash' || e.key === '/') setIsOpen(true)
  }

  useEffect(() => {
    Modal.setAppElement('#___gatsby')
    window.addEventListener('keyup', onSlashKey)
    return () => window.removeEventListener('keyup', onSlashKey)
  }, [])

  function handleClose() {
    setIsOpen(false)
  }

  function handleOpen() {
    setIsOpen(true)
  }
  return (
    <>
      <GlobalStyle></GlobalStyle>
      <button
        className="flex items-center justify-center w-10 h-10 focus:text-sol-blue hover:text-sol-blue"
        onClick={handleOpen}
        aria-label="open search"
      >
        <MdSearch className="w-4 h-4 pointer-events-none fill-current"></MdSearch>
      </button>
      <Modal
        className="modal"
        overlayClassName="overlay"
        isOpen={modalIsOpen}
        onRequestClose={handleClose}
        contentLabel="search"
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        {asyncIndex.result && asyncStore.result && (
          <Search closeModal={handleClose} index={asyncIndex.result} store={asyncStore.result} />
        )}
      </Modal>
    </>
  )
}
